import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
	PostCodeRHF,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../../common/constants";

import { Box } from "@mui/material";
import { CityService } from "../../../../services/CityService";
import { CountryService } from "../../../../services/common/CountryService";
import { IAppState } from "../../../../store/reducers";
import { ProvinceService } from "../../../../services/common/ProvinceService";
import { sortDDLByLabel, useNavigateToLogout } from "../../../../common/Common";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

interface IEmployeeAddressSetupFieldsPanel extends ITest {
	countryList: {
		shortCode?: string;
		label: string;
		value: string;
		countryType: string;
	}[];
	provinceDDLLoading: (value: boolean) => void;
	formMethods: any;
	provinceStateDDLinUpdate: any;
	provinceDDLItems: any;
	provinceStateLabelinUpdate: any;
	isAdminUser: any;
	cityDDLinUpdate: any;
}

export const EmployeeAddressSetupFieldsPanel: FC<
	IEmployeeAddressSetupFieldsPanel
> = ({
	testId,

	countryList,
	provinceDDLLoading,
	formMethods,
	provinceStateDDLinUpdate,
	provinceDDLItems,
	provinceStateLabelinUpdate,
	isAdminUser,
	cityDDLinUpdate,
}) => {
		const canadaProvinces = useSelector((state: IAppState) => state.countryAndProvincesInfo.canadaProvinces);
		const canada = useSelector((state: IAppState) => state.countryAndProvincesInfo.canada);
		const [provinceOrStateDDL, setprovinceOrStateDDL] = useState<any>(undefined);
		const [cityDDL, setCityDDL] = useState(undefined);
		const [countrytype, setCountrytype] = useState("Province");
		const [selectedCountryShortCode, setSelectedCountryShortCode] =
			useState<any>("");
		const [selectedCountry, setSelectedCountry] = useState<any>("");
		// const useGetProvinceDDL = () => {
		// 	return useQuery(GET_QUERY_KEY.PROVINCE_DDL, () => ProvinceService.get(), {
		// 		...QUERY_OPTIONS,
		// 	});
		// };
		// const { data: provinceList } = useGetProvinceDDL();
		const navigateToLogout = useNavigateToLogout();

		// const useGetStateDDL = () => {
		// 	return useQuery(GET_QUERY_KEY.USA_STATE_DDL, () => StateService.get(), {
		// 		...QUERY_OPTIONS,
		// 	});
		// };
		// const { data: stateList } = useGetStateDDL();

		const onCountryChangeHandler = async (e: any) => {
		
			setSelectedCountryShortCode(e.shortCode);
			setSelectedCountry(e.value);
			let selected = e.value;
			setCountrytype(
				e.countryType === "province"
					? "Province"
					: e.countryType === "state"
						? "State"
						: e.countryType
			);
			formMethods.setValue("province", undefined);
			formMethods.setValue("state", undefined);
			try {
				provinceDDLLoading(true);
				const responce = await CountryService.getProvinceOrStateDDL(
					navigateToLogout,
					selected,
					e.countryType
				);
				setprovinceOrStateDDL(responce);
				provinceDDLItems(responce);
			} catch {
			
			} finally {
				provinceDDLLoading(false);
			}
		};
		const onProvinceChangeHandler = async (e: any) => {
			let selected = e.value;
			formMethods.setValue("city", undefined);
			try {
				provinceDDLLoading(true);
				const responce = await CityService.getCityDDL(navigateToLogout, selected);
				setCityDDL(responce);
			} catch {
				
			} finally {
				provinceDDLLoading(false);
			}
		};
		useEffect(() => {
			if (provinceStateDDLinUpdate && provinceStateLabelinUpdate) {
				
				setprovinceOrStateDDL(provinceStateDDLinUpdate);
				provinceDDLItems(provinceStateDDLinUpdate);
				setCountrytype(
					provinceStateLabelinUpdate === "province"
						? "Province"
						: provinceStateLabelinUpdate === "state"
							? "State"
							: provinceStateLabelinUpdate
				);
			}
			if (cityDDLinUpdate) {
				setCityDDL(cityDDLinUpdate);
			}
			// if (countryList && Array.isArray(countryList)) {
			// 	const canada = countryList.find(
			// 		(item: any) => item.label === "Canada" || "canada"
			// 	);
			// 	if (canada) {
			// 		setSelectedCountryShortCode(canada.shortCode);
			// 		setSelectedCountry(canada.value);
			// 		(async () => {
			// 			try {
			// 				provinceDDLLoading(true);
			// 				const response = await CountryService.getProvinceOrStateDDL(
			// 					navigateToLogout,
			// 					canada.value,
			// 					"Province"
			// 				);
			// 				setprovinceOrStateDDL(response);
			// 				provinceDDLItems(response);
			// 			} catch (err) {
			// 				console.error("error", err);
			// 			} finally {
			// 				provinceDDLLoading(false);
			// 			}
			// 		})();
			// 	}
			// }
			if (canada && canada?.shortCode === 'CAN' && canadaProvinces) {
				setSelectedCountryShortCode(canada.shortCode);
				setSelectedCountry(canada.value);
				setprovinceOrStateDDL(canadaProvinces);
				provinceDDLItems(canadaProvinces);
			}
		}, [
			provinceStateLabelinUpdate,
			provinceStateDDLinUpdate,
			countryList,
			cityDDLinUpdate,
			canada,
			canadaProvinces
		]);

	
		return (
			<>
				<RHookFormTextFieldWithLabel
					label="Address"
					id="address"
					testId={`${testId}-employee-address`}
					labelPosition={LabelPosition.Top}
					required
				/>
				{countryList && selectedCountry && (
					<EnhancedDropDownRHFWithLabel
						selectName="country"
						label="Country"
						labelPosition={LabelPosition.Top}
						// required
						testId={`country-list`}
						items={countryList ?? []}
						selectedItem={selectedCountry}
						labelColumns={4}
						fieldColumns={8}
						onSelectionChangeHandler={onCountryChangeHandler}
					/>
				)}
				{provinceOrStateDDL && (
					<EnhancedDropDownRHFWithLabel
						selectName={"province"}
						label={countrytype}
						labelPosition={LabelPosition.Top}
						// required
						testId={`province-list`}
						items={provinceOrStateDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
						onSelectionChangeHandler={onProvinceChangeHandler}
					/>
				)}

				{provinceOrStateDDL && cityDDL && (
					<EnhancedDropDownRHFWithLabel
						selectName={"city"}
						label={"City"}
						labelPosition={LabelPosition.Top}
						// required
						testId={`city-list`}
						items={cityDDL && sortDDLByLabel(cityDDL ?? [])}
					/>
				)}

				{selectedCountryShortCode === "CAN" ? (
					<PostCodeRHF
						label="Post Code"
						id="postCode"
						testId={`accountant-post-code`}
						labelPosition={LabelPosition.Top}
						labelColumns={4}
						fieldColumns={8}
					// required
					/>
				) : selectedCountryShortCode === "USA" ? (
					<RHookFormMaskedTextFieldWithLabel
						label="Zip Code"
						id="zipCode"
						testId={`Zip-Code`}
						labelPosition={LabelPosition.Top}
						placeholder={"00000"}
						// required
						inputMaskPattern={"00000"}
						labelColumns={4}
						fieldColumns={8}
					/>
				) : (
					<></>
				)}
				<EmailFieldRHF
					label="Email"
					id="email"
					testId={`${testId}-employee-email`}
					labelPosition={LabelPosition.Top}
					labelColumns={4}
					fieldColumns={8}
				/>
			</>
		);
	};
